<div class="w-full min-w-0 max-w-full max-h-[60dvh] overflow-x-auto overflow-y-auto touch-auto">
<table mat-table [dataSource]="tableRows" class="documents-table">
  <ng-container matColumnDef="document">
    <th mat-header-cell *matHeaderCellDef>Document</th>
    <td mat-cell *matCellDef="let row">
      @if (row.url) {
        <span class="inline-flex items-center gap-1">
          <a [href]="row.url" target="_blank" rel="noopener noreferrer">{{ row.document }}</a>
          <button
            type="button"
            class="inline-flex cursor-pointer items-center p-0 disabled:cursor-wait disabled:opacity-50"
            [attr.aria-label]="'Print ' + row.document"
            [disabled]="printingDocumentId !== null"
            (click)="printDocument(row)"
            >
            <mat-icon aria-hidden="true">print</mat-icon>
          </button>
        </span>
      } @else {
        {{ row.document }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef>DOS</th>
    <td mat-cell *matCellDef="let row">{{ row.date | date: 'MM/dd/yyyy hh:mm a' }}</td>
  </ng-container>

  <ng-container matColumnDef="provider">
    <th mat-header-cell *matHeaderCellDef>Provider</th>
    <td mat-cell *matCellDef="let row">{{ row.provider }}</td>
  </ng-container>

  <tr class="sticky top-0 z-10 bg-white" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>

@if (appointmentDocumentData.isLoading()) {
  <div class="w-full flex justify-center items-center detail-spinner"><mat-spinner></mat-spinner></div>
}

@if (!appointmentDocumentData.isLoading() && tableRows.length === 0) {
  <div class="documents-empty-state">
    No documents available.
  </div>
}
